"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendUserEvents = exports.addToBasket = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const addToBasket = ({
  id
}) => window.dispatchEvent(new CustomEvent(AddToBasketEvent.Name, {
  detail: {
    itemCode: id,
    quantity: 1
  }
}));
exports.addToBasket = addToBasket;
const sendUserEvents = ({
  payload
}) => {
  if (payload.payload) {
    const {
      category,
      items
    } = payload.payload;
    if (category === _constants.TRACKING_CATEGORY_PRODUCT_RECOMMENDATION && items) {
      UserAction.dispatch([..._constants.USER_ACTION_DIAGNOSIS_COMPLETED, items.map(p => p.item_id).join(',')]);
    }
  }
  switch (payload.title) {
    case _constants.TRACKING_TITLE_CONDITIONS:
      UserAction.dispatch([..._constants.USER_ACTION_DIAGNOSIS_STARTED, _constants.WITHOUT_SELFIE]);
      break;
    case _constants.TRACKING_TITLE_SELFIE:
      UserAction.dispatch([..._constants.USER_ACTION_DIAGNOSIS_STARTED, _constants.WITH_SELFIE]);
      break;
    default:
      break;
  }
};
exports.sendUserEvents = sendUserEvents;
